const defaultFontSize = 10

export default function setRemSize(size = 1920) {
    const width = window.innerWidth
    const proportion = width / size
    const fontSize = defaultFontSize * proportion
    document.documentElement.style.fontSize = fontSize + 'px'
}